import * as React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import CancelIcon from '@mui/icons-material/Cancel';

const CustomPaper = (props) => (
  <div className="dependency-list-paper">
    <Paper {...props} />
  </div>
);
const propTypes = {
  api: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  onAutoCompleteChange: PropTypes.func,
  OnDeleteDependency: PropTypes.func,
  data: PropTypes.oneOfType([PropTypes.object]),
};

const defaultProps = {
  api: () => {},
  onAutoCompleteChange: () => {},
  OnDeleteDependency: () => {},
  data: [],
};
const Dependency = React.forwardRef(
  ({ api, data, onAutoCompleteChange, OnDeleteDependency }, ref) => {
    const rowData = [];
    api.forEachNode((node) => rowData.push(node.data));
    const propData = rowData?.map((row) => ({
      id: row?.id,
      epicId: row?.epicId,
      summary: row?.summary,
      dependency: row?.dependency,
    }));
    // list that doesn't allow for circular dependency
    const dependencyCheckArr = [];
    propData?.forEach((dependentData) => {
      dependentData?.dependency?.forEach((dependent) => {
        const element = {
          epicId: dependentData?.id,
          dependsOn: dependent?.depends?.id,
        };
        dependencyCheckArr.push(element);
      });
    });
    const finalDependencyList = [];
    const dependencyCheck = (id) => {
      dependencyCheckArr?.forEach((dependencyCheckElement) => {
        if (id === dependencyCheckElement.dependsOn) {
          if (!finalDependencyList.includes(dependencyCheckElement.epicId)) {
            finalDependencyList.push(dependencyCheckElement.epicId);
          }
          dependencyCheck(dependencyCheckElement.epicId);
        }
      });
    };

    dependencyCheckArr.forEach((dependencyCheckElement) => {
      if (data.id === dependencyCheckElement.dependsOn) {
        if (!finalDependencyList.includes(dependencyCheckElement.epicId)) {
          finalDependencyList.push(dependencyCheckElement.epicId);
        }
        dependencyCheck(dependencyCheckElement.epicId);
      }
    });

    const dependencyList = propData.filter(
      (dep) => !finalDependencyList.includes(dep.id) && !data.id.includes(dep.id),
    );
    let defaultValueIds;
    propData.forEach((propDataItem) => {
      if (data.id === propDataItem.id) {
        defaultValueIds = propDataItem.dependency?.map((dependency) => dependency?.depends?.id);
      }
    });

    const defaultValues = propData.filter((d) => defaultValueIds.includes(d.id));

    const onChangeCustom = (value) => {
      const dependencies = value.filter((dep) => !defaultValueIds.includes(dep.id));
      onAutoCompleteChange(dependencies);
      const deleteDependency = defaultValues.filter((d) => !value.includes(d));
      OnDeleteDependency(deleteDependency);
    };
    return (
      <Autocomplete
        className="dependency-list"
        multiple
        id="tags-standard"
        options={dependencyList || ''}
        filterSelectedOptions
        open
        ChipProps={{ deleteIcon: <CancelIcon /> }}
        defaultValue={defaultValues || ''}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        onChange={(e, value) => onChangeCustom(value)}
        getOptionLabel={(option) => `${option.epicId} ${option.summary}`}
        PaperComponent={CustomPaper}
        renderInput={(params) => <TextField {...params} ref={ref.current} component="div" />}
      />
    );
  },
);

Dependency.propTypes = propTypes;
Dependency.defaultProps = defaultProps;
export default Dependency;
